import { render, staticRenderFns } from "./UiPagination.vue?vue&type=template&id=1665c966&scoped=true&"
import script from "./UiPagination.vue?vue&type=script&lang=js&"
export * from "./UiPagination.vue?vue&type=script&lang=js&"
import style0 from "./UiPagination.vue?vue&type=style&index=0&id=1665c966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1665c966",
  null
  
)

export default component.exports